import * as GAEvents from '../../../google_analytics/navigation';

export const sendClickToGa = (level, labelElements) => {
    const label = labelElements.join(' > ');

    level === 1
        ? GAEvents.clockOnLevel1Link(label)

    : level === 2
        ? GAEvents.clockOnLevel2Link(label)

    : level === 3
        ? GAEvents.clockOnLevel3Link(label)

    : null;
};
